import { property } from 'lit/decorators.js';
import { KryptonElement } from '../elements/krypton-element';

export abstract class PublicAppElement extends KryptonElement {
    protected runMode: string = '';
    get systemEnv(): string {
        return this.runMode;
    }

    @property({ type: String })
    set systemEnv(value: string) {
        const oldValue = this.runMode;
        this.runMode = value;
        this.requestUpdate('systemEnv', oldValue);
    }
    protected runVersion: string = '';

    get appVersion(): string {
        return this.runVersion;
    }

    @property({ type: String })
    set appVersion(value: string) {
        const oldValue = this.runVersion;
        this.runVersion = value;
        this.requestUpdate('appVersion', oldValue);
    }

    publicApp(): any {
        return window["publicApp"]();
    }
    getPublicAppElementForSelector(selector: string) {
        return this.querySelector(selector) || this.shadowRoot?.querySelector(selector)
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'public-app-element': PublicAppElement;
    }
}
